import React, { useEffect, useState, useRef, useContext } from 'react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import InputMask from 'react-input-mask';
import CurrencyInput from 'react-currency-input';
import { URLBunge } from "./Componentes/Config";
import { LogAcesso, AlertForm, AlertRedirect, MascaraCNPJ } from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import MenuPrinc from "./Componentes/MenuPrinc";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import { withStyles } from "@material-ui/core/styles";
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import {
  Clear,
  BackgroundImg,
  TitNoticias,
  ColunaRegras,
  BtVoltar,
  TextoDescPesquisa,
  CampoFormCadastro,
  FormPesquisa,
  DescCampo,
  BotaoEnviarPesquisa,
  BtIcoBuscar,
  CampoFormBusca,
  ClienteProdutoSelecionado,
} from './Estilos'

import IcoBusca from './Images/ico_search_branco.png'
import ImgBtSetaVoltar from "./Images/BtSeta.png";

function AcademiaFinalizarRequisicao(props) {

  const history = useHistory();
  const location = useLocation();
  const [ Loading, setLoading ] = useState(false);
  const { register, handleSubmit, errors, control, setValue } = useForm();

  const [ NomeEvento, setNomeEvento ] = useState("Minha Bunge Vendas");
  const [ Token, setToken ] = useState(localStorage.getItem("c_token"));
  const [ IdUser, setIdUser ] = useState(localStorage.getItem("id_tb_user"));
  const [ CPFUser, setCPFUser ] = useState(localStorage.getItem("c_cpf"));

  useEffect(() => {
    if (Token === null) {
        history.push({ pathname: '/', state: {} });
    } else {
        LogAcesso(Token, "Academia - Requisições de Atendimento - Vendedor")
    }
  }, []);

  const [ TextoAguarde, setTextoAguarde ] = useState(false);
  const [ RealizouCompra, setRealizouCompra ] = useState("");
  const GreenRadio = withStyles({
    root: {
      color: '#DDDDDD',
      "&$checked": {
        color: '#FFFFFF'
      }
    },
    checked: {}
  })((props) => <Radio color="default" {...props} />);


  var idRequisicao = location.state.idRequisicao;

  const EnviarPesquisa = async (data, e) => {  
      console.log(idRequisicao);

    if(RealizouCompra === ""){
        AlertForm("Efetuou a venda?");
        e.preventDefault();
        return false
    }

    if(RealizouCompra == 0){
        if(data.c_obs === '' || data.c_obs === undefined){
            AlertForm("Por favor, explique o motivo?");
            e.preventDefault();
            return false
        }
    }
    
    setTextoAguarde(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
    myHeaders.append("Content-Type", "application/json");
    
    var raw = JSON.stringify({
      "idRequisicao": idRequisicao,
      "efetuouVendas": RealizouCompra == 0 ? false : true,
      "motivo": data.c_obs
    });
    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    
    fetch(`${URLBunge}/api/Requisicoes/CadRequisicaoComplementar`, requestOptions)
    .then(response => response.json())
    .then(result => {

      if(result.sucesso === true) {
        AlertRedirect('Sua requisição foi finalizada com sucesso!', 'AcademiaFormularioListaRequisicoes', history);
        setLoading(false);
      } else {
        AlertForm(result.mensagem);
        setLoading(false);
      }
    
    })
    .catch(error => {console.log('error', error); setTextoAguarde(false) });

  };


  return (
    <>  
        <CabecalhoPagina NomeEvento={NomeEvento} />
        {Loading === true ? <Carregando /> : null }

        <BackgroundImg Background={''} BackgroundMob={''} bgcolor={'#FFFFFF'}>

            
        <ColunaRegras>
                <div className={'AreaColunaRegras'}>

                    <TitNoticias>Finalizar Atendimento</TitNoticias>
                    <Clear />

                    <TextoDescPesquisa>Formulário para pesquisa de preços.</TextoDescPesquisa>
                    <Clear />

                    <BtVoltar onClick={()=>history.push({ pathname: '/AcademiaFormularioListaRequisicoes', state: {} })} style={{marginLeft: 'auto', marginRight: 'auto'}}>
                      <img src={ImgBtSetaVoltar} /> <div>VOLTAR</div>
                    </BtVoltar>

                    <FormPesquisa onSubmit={handleSubmit(EnviarPesquisa)}>

                        <CampoFormCadastro>
                            <DescCampo>Efetuou a venda? {RealizouCompra}</DescCampo>
                            <aside>                          
                                <RadioGroup aria-label="gender" name="gender1" value={RealizouCompra === '' ? 3 : Number(RealizouCompra)} onChange={(e)=>setRealizouCompra(e.target.value)} style={{flexDirection: 'row'}}>
                                    <FormControlLabel value={1} control={<GreenRadio color="primary" />} label={'SIM'}/>
                                    <FormControlLabel value={0} control={<GreenRadio color="primary" />} label={'NÃO'}/>
                                </RadioGroup>
                            </aside>                          
                        </CampoFormCadastro>

                        {
                            RealizouCompra === '' ? null :
                                RealizouCompra == 1 ? null :
                                    <CampoFormCadastro>
                                        <Controller
                                            control={control}
                                            ref={register}
                                            id="c_obs"
                                            name="c_obs"
                                            type="text"
                                            placeholder={'Se não, por quê?'}
                                            className="CampoForm CampoFormLogin"
                                            as={InputMask}
                                            mask=""
                                        />
                                    </CampoFormCadastro>
                        }


                        
                        { TextoAguarde === false ?
                            <BotaoEnviarPesquisa type="submit">ENVIAR PESQUISA</BotaoEnviarPesquisa>
                        :
                            <BotaoEnviarPesquisa disabled>AGUARDE...</BotaoEnviarPesquisa>
                        }

                        <Clear />


                        </FormPesquisa>



                    
                </div>  
            </ColunaRegras>
            


            <MenuPrinc Pagina="Pesquisas" />
         </BackgroundImg>
    </>
  );

}

export default AcademiaFinalizarRequisicao;
